import React, { type FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import classes from './FooterInfo.module.scss'
import { ChannelBadge } from '../../../badges/ChannelBadge/ChannelBadge'

type FooterInfoProps = {
  game: FeedData
}
export const FooterInfo: FC<FooterInfoProps> = ({ game }) => {
  const channelName = game.channelName

  if (!channelName) {
    return null
  }

  return (
    <div className={classes.Container}>
      <div className={classes.Badges}>
        {<ChannelBadge channelName={channelName} />}
      </div>
      <span></span>
    </div>
  )
}
